module.exports = __webpack_public_path__ + "static/media/icon-social_media-whatsapp.07fae2fd.svg";